import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import {
  CATALOG_SETTINGS_DOC,
  CUSTOMIZATION,
  DEFAULT_CATALOG_VITRINE_SETTINGS,
} from '../constants/catalogVitrineSettings';
import { resolveCatalogVitrineSettings } from '../utils/resolveCatalogVitrineSettings';

const SETTINGS = 'settings';

async function readLegacyFilterByUserProducts() {
  try {
    const settingsSnap = await getDoc(doc(firestore, CUSTOMIZATION, SETTINGS));
    if (!settingsSnap.exists()) return undefined;
    if (typeof settingsSnap.data().filterByUserProducts !== 'boolean') {
      return undefined;
    }
    return settingsSnap.data().filterByUserProducts;
  } catch {
    return undefined;
  }
}

export { CATALOG_SETTINGS_DOC, CUSTOMIZATION, DEFAULT_CATALOG_VITRINE_SETTINGS };

export const useCatalogVitrineSettings = () => {
  return useQuery({
    queryKey: [CUSTOMIZATION, CATALOG_SETTINGS_DOC, SETTINGS, 'legacy'],
    queryFn: async () => {
      try {
        const [catalogSnap, legacy] = await Promise.all([
          getDoc(doc(firestore, CUSTOMIZATION, CATALOG_SETTINGS_DOC)),
          readLegacyFilterByUserProducts(),
        ]);
        return resolveCatalogVitrineSettings(catalogSnap, legacy);
      } catch {
        return {
          ...DEFAULT_CATALOG_VITRINE_SETTINGS,
          fromLegacyFilters: false,
          configuredViaCatalogModal: false,
        };
      }
    },
    staleTime: 1000 * 60 * 5,
  });
};
